// extracted by mini-css-extract-plugin
export const header = "Header-module--header--1SOeU";
export const logo = "Header-module--logo--yA8t0";